export default __webpack_public_path__ + "static/media/img-2.78d71f63.png";